import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./CustomSoftwareServices.css";
import itManagers from "../../../../Assets/Images/Services/Custom Software Dev/IT Managers.svg";
import nonItManagers from "../../../../Assets/Images/Services/Custom Software Dev/Non IT Managers.svg";
import startups from "../../../../Assets/Images/Services/Custom Software Dev/Startup-icon.svg";
import { Link } from "react-router-dom";

export const CustomSoftwareServices = () => {
  return (
    <div id="target-group" className="service-container">
      <div className="service-title-desc text-center text-white">
        <h1 className="service-title">
          For Teams Ready To Build Something Real
        </h1>
        <p className="service-desc">
          Most of the people we work with are already burdened by the weight of
          a growing product. Things are moving fast, systems are starting to
          strain and quick fixes are no longer enough. We're working with
          founders, product leaders, and teams that want to take just enough
          time to build software that actually helps with where they are going
          next.
        </p>
        <Link to="/contact-us">
          <button className="service-button">LET'S START</button>
        </Link>
      </div>
      <div className="service-img">
        <div className="img">
          <div className="circle">
            <img src={itManagers} alt="IT Managers" className="img-fluid" />
          </div>
          <p className="img-title">IT Managers</p>
        </div>

        <div className="img">
          <div className="circle">
            <img
              src={nonItManagers}
              alt="Non-IT Managers"
              className="img-fluid"
            />
          </div>
          <p className="img-title">Non-IT Managers</p>
        </div>

        <div className="img">
          <div className="circle">
            <img src={startups} alt="Startups" className="img-fluid" />
          </div>
          <p className="img-title">Startups</p>
        </div>
      </div>
    </div>
  );
};
